/* Mostrar mais e Mostrar menos - Descrições */

function MostrarMaisMostrarMenos() {
  var dots = document.getElementById("dj_dots");
  var moreText = document.getElementById("dj_mais");
  var btnText = document.getElementById("dj_botao");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Mostrar Mais [+]";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Mostrar Menos [-]";
    moreText.style.display = "inline";
  }
}

function ReadMoreReadLess() {  
	var dots = document.getElementById("dj_dots");  
	var moreText = document.getElementById("dj_mais");  
	var btnText = document.getElementById("dj_botao");

if (dots.style.display === "none") {    
	dots.style.display = "inline";    
	btnText.innerHTML = "Read More [+]";    
	moreText.style.display = "none";  
} else {    
	dots.style.display = "none";
	btnText.innerHTML = "Read Less [-]";
	moreText.style.display = "inline";
 }
}